import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Container } from '@vnetwork/ui/layout';
import { Skeleton } from '@vnetwork/ui/primitives';
import { useMyServices } from '@/api/services';
import { WAAP_PROVIDER, waapConsoleRoute } from './waap-service';
import { WaapActivateLanding } from './WaapActivateLanding';

/**
 * Landing gate for the WAAP module at /services/waap (no serviceId) — mirrors the
 * Healthcheck WorkspaceGate. One look at the org's services decides what renders:
 *   - loading          → skeleton
 *   - WAAP service      → redirect into its console
 *   - none              → the activation hero (WaapActivateLanding)
 * Reached from the services dashboard card (WAAP's `consoleRoute`).
 */
export function WaapLandingGate() {
  const { data: services = [], isLoading } = useMyServices();

  const existing = useMemo(
    () => services.find((s) => s.provider?.name?.trim().toLowerCase() === WAAP_PROVIDER),
    [services],
  );

  if (isLoading) {
    return (
      <Container size="xl">
        <Skeleton style={{ height: 200 }} />
      </Container>
    );
  }

  if (existing) {
    return <Navigate to={waapConsoleRoute(existing.id)} replace />;
  }

  return <WaapActivateLanding />;
}

export default WaapLandingGate;
